import * as React from "react";

interface IProps {
  size: number;
  color?: string;
}
const RightArrow: React.FC<IProps> = ({ size, color = undefined }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.488 15.167l-5.244-5.244 1.178-1.179L24.678 16l-7.256 7.256-1.178-1.178 5.244-5.245H7.666v-1.666h13.822z"
        fill={color}
      />
    </svg>
  );
};

export default RightArrow;
